import React from 'react';
import CurrencyFormat from 'react-currency-format';
import { Row, Col } from 'reactstrap';
import PriceTooltip from '@components/Quoting/Board/Pricing/PricingRow/PriceTooltip/PriceTooltip';
import FlightTime from '@components/FlightTime/FlightTime';

const legInfo = props => {
  let timeLabel = '';
  if (props.flight_time === 0) {
    timeLabel = 'n/a';
  } else {
    const flightTime = props.flight_time.split(':');
    const hours =
      parseInt(flightTime[0], 10) > 0 ? parseInt(flightTime[0], 10) : false;
    const minutes = parseInt(flightTime[1], 10);
    timeLabel = (
      <React.Fragment>
        {hours && <span>{hours} hour(s)&nbsp;&nbsp;</span>}
        {minutes} minute(s)
      </React.Fragment>
    );
  }

  return (
    <div className={'position-relative mb-3'}>
      <div
        className={'color-red text-uppercase lakes-medium font-sm text-left'}
      >
        Leg {props.index} Information
      </div>
      <div
        className={
          'border-grey background-white font-sm text-left' +
          (props.isMobile ? ' p-2' : ' p-3')
        }
      >
        <div
          className={
            'color-red lakes-medium' +
            (props.isMobile ? ' font-sm' : ' font-md')
          }
        >
          Flight Information
        </div>

        <table
          className={'table js-table table-sm table-jetsuite font-sm text-left'}
        >
          <thead>
            <tr>
              <th style={{ width: '50%' }}>Flight Route</th>
              <th style={{ width: '50%' }} className={'color-red'}>
                {props.aircraft}
              </th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>Departure Airport</td>
              <td>{props.departure_airport.name}</td>
            </tr>
            <tr>
              <td>Arrival Airport</td>
              <td>{props.arrival_airport.name}</td>
            </tr>
          </tbody>
          <thead>
            <tr>
              <th colSpan={2}>Flight Time</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>Departure Date</td>
              <td>{props.departure_datetime.split(' ')[0]}</td>
            </tr>
            <tr>
              <td>Departure Time (local)</td>
              <td>
                {props.departure_datetime.split(' ')[1]}{' '}
                {props.departure_datetime.split(' ')[2]}
              </td>
            </tr>
            <tr>
              <td>Flight Time</td>
              <td>{timeLabel}</td>
            </tr>
            <tr>
              <td>Estimated Arrival Time (local)</td>
              <td>
                {props.arrival_datetime !== false ? (
                  <span>
                    {props.arrival_datetime.split(' ')[1]}{' '}
                    {props.arrival_datetime.split(' ')[2]}
                  </span>
                ) : (
                  'n/a'
                )}
              </td>
            </tr>
          </tbody>
          {props.contractVersion !== 2 && (
            <React.Fragment>
              <thead>
                <tr>
                  <th>Components</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>{props.departure_airport.name}</td>
                  <td>
                    {props.fees !== false ? (
                      <span>
                        <CurrencyFormat
                          value={
                            props.fees[props.departure_airport.id].total_fee
                          }
                          displayType={'text'}
                          thousandSeparator={true}
                          prefix={'$'}
                          decimalScale={2}
                          fixedDecimalScale={true}
                        />
                        {/*<PriceTooltip
                      tooltipOpen={props.tooltipOpen}
                      index={`departure-airport-${props.index}`}
                      toggleTooltip={props.toggleTooltip}
                      fees={props.fees[props.departure_airport.id].items}
                    />*/}
                      </span>
                    ) : (
                      'n/a'
                    )}
                  </td>
                </tr>
                {props.discount !== 0 && (
                  <tr>
                    <td>{props.departure_airport.name} Launch Special</td>
                    <td>
                      <span className={'color-red'}>
                        <CurrencyFormat
                          value={props.discount}
                          displayType={'text'}
                          thousandSeparator={true}
                          prefix={'$'}
                          decimalScale={2}
                          fixedDecimalScale={true}
                        />
                      </span>
                    </td>
                  </tr>
                )}
                <tr>
                  <td>{props.arrival_airport.name}</td>
                  <td>
                    {props.fees !== false ? (
                      <span>
                        <CurrencyFormat
                          value={props.fees[props.arrival_airport.id].total_fee}
                          displayType={'text'}
                          thousandSeparator={true}
                          prefix={'$'}
                          decimalScale={2}
                          fixedDecimalScale={true}
                        />
                        {/*<PriceTooltip
                      tooltipOpen={props.tooltipOpen}
                      index={`arrival-airport-${props.index}`}
                      toggleTooltip={props.toggleTooltip}
                      fees={props.fees[props.arrival_airport.id].items}
                    />*/}
                      </span>
                    ) : (
                      'n/a'
                    )}
                  </td>
                </tr>

                <tr>
                  <td>Flight Time Rate</td>
                  <td>
                    {props.total > 0 ? (
                      <span>
                        <CurrencyFormat
                          value={
                            props.total -
                            props.fees[props.arrival_airport.id].total_fee -
                            props.fees[props.departure_airport.id].total_fee -
                            props.discount
                          }
                          displayType={'text'}
                          thousandSeparator={true}
                          prefix={'$'}
                          decimalScale={2}
                          fixedDecimalScale={true}
                        />
                        <PriceTooltip
                          tooltipOpen={props.tooltipOpen}
                          index={`flight-rate-${props.index}`}
                          toggleTooltip={props.toggleTooltip}
                          fees={[]}
                          items={[
                            <FlightTime flight_time={props.flight_time} />
                          ]}
                          title={'Flight Time'}
                        />
                      </span>
                    ) : (
                      'n/a'
                    )}
                  </td>
                </tr>
              </tbody>

              <thead>
                <tr>
                  <th>Pricing</th>
                  <th>{props.aircraft}</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td className={'font-sm lakes-bold'}>Leg 1 total</td>
                  <td className={'font-sm lakes-bold'}>
                    {props.total > 0 ? (
                      <CurrencyFormat
                        value={props.total}
                        displayType={'text'}
                        thousandSeparator={true}
                        prefix={'$'}
                        decimalScale={2}
                        fixedDecimalScale={true}
                      />
                    ) : (
                      'n/a'
                    )}
                  </td>
                </tr>
              </tbody>
            </React.Fragment>
          )}
        </table>
        <div
          className={
            'color-red lakes-medium pb-2' +
            (props.isMobile ? ' font-sm' : ' font-md')
          }
        >
          Airport {props.legInfo.fromCode}
        </div>
        <table
          className={'js-table table table-sm table-jetsuite font-sm text-left'}
        >
          <tbody>
            <tr>
              <td className={'font-sm lakes-bold'} style={{ width: '33%' }}>
                Ground Arrangement
                <br />
                Specifications:
              </td>
              <td className={'font-sm'}>{props.legInfo.from_specifications}</td>
            </tr>
            <tr>
              <td className={'font-sm lakes-bold'}>
                Catering
                <br />
                Specifications:
              </td>
              <td className={'font-sm'}>
                {props.legInfo.from_catering_specifications}
              </td>
            </tr>
          </tbody>
        </table>

        <div
          className={
            'color-red lakes-medium pb-2' +
            (props.isMobile ? ' font-sm' : ' font-md')
          }
        >
          Airport {props.legInfo.toCode}
        </div>
        <table
          className={'js-table table table-sm table-jetsuite font-sm text-left'}
        >
          <tbody>
            <tr>
              <td className={'font-sm lakes-bold'} style={{ width: '33%' }}>
                Ground Arrangement
                <br />
                Specifications:
              </td>
              <td className={'font-sm'}>{props.legInfo.to_specifications}</td>
            </tr>
            <tr>
              <td className={'font-sm lakes-bold'}>
                Catering
                <br />
                Specifications:
              </td>
              <td className={'font-sm'}>
                {props.legInfo.to_catering_specifications}
              </td>
            </tr>
          </tbody>
        </table>

        <div
          className={
            'color-red lakes-medium pb-2' +
            (props.isMobile ? ' font-sm' : ' font-md')
          }
        >
          Passenger Information
        </div>
        <table
          className={'js-table table table-sm table-jetsuite font-sm text-left'}
        >
          <tbody>
            {props.passengers.passengers.map((passenger, index) => {
              return (
                <tr key={index}>
                  <td className={'font-sm lakes-bold'}>
                    {index > 0 ? (
                      <React.Fragment>
                        Passenger {index + 1}
                        {((props.aircraftKey === 'E50P' && index === 4) ||
                          index === 7) && (
                          <span className={'color-red'}>
                            &nbsp;(Infant Only)
                          </span>
                        )}
                        :
                      </React.Fragment>
                    ) : (
                      'Lead Passenger:'
                    )}
                  </td>
                  <td className={'font-sm'}>
                    {`${passenger.firstName.value} ${
                      passenger.lastName.value
                    } (${passenger.weight.value})lbs ${passenger.dob.value}`}
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
        <div
          className={
            'color-red lakes-medium' +
            (props.isMobile ? ' font-sm' : ' font-md')
          }
        >
          More Passenger Information
        </div>
        <Row>
          <Col>
            <table
              className={
                'js-table table table-sm table-jetsuite font-sm text-left'
              }
            >
              <tbody>
                <tr>
                  <td className={'font-sm lakes-bold'} style={{ width: '30%' }}>
                    Dogs
                  </td>
                  <td>
                    {props.passengers.dogsNo > 0 ? (
                      <span>{props.passengers.dogsNo}</span>
                    ) : (
                      <span>None</span>
                    )}
                    {props.passengers.dogsNo >= 1 &&
                      `, (${props.passengers.dogWeight1.value})lbs`}
                    {props.passengers.dogsNo >= 2 &&
                      `, (${props.passengers.dogWeight2.value})lbs`}
                  </td>
                </tr>
                <tr>
                  <td className={'font-sm lakes-bold'}>Cats</td>
                  <td>
                    {props.passengers.catsNo > 0 ? (
                      <span>{props.passengers.catsNo}</span>
                    ) : (
                      <span>None</span>
                    )}
                    {props.passengers.catsNo >= 1 &&
                      `, (${props.passengers.catWeight1.value})lbs`}
                    {props.passengers.catsNo >= 2 &&
                      `, (${props.passengers.catWeight2.value})lbs`}
                  </td>
                </tr>
              </tbody>
            </table>
          </Col>
        </Row>
        <div
          className={
            'color-red lakes-medium' +
            (props.isMobile ? ' font-sm' : ' font-md')
          }
        >
          Total Luggage Weight
        </div>
        <table
          className={'js-table table table-sm table-jetsuite font-sm text-left'}
        >
          <tbody>
            <tr>
              <td style={{ border: 'none' }}>
                ({props.passengers.totalLuggageWeight.value}
                )lbs
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  );
};
export default legInfo;



// WEBPACK FOOTER //
// ./src/components/Quoting/Board/TripSummary/LegInfo/LegInfo.jsx